<template>
  <div 
    class="results-table__head table-flex-header-cell"
    :style="configItem.style"
    :title="configItem.label"
  >
    <svg
      v-if="sortable"
      class="results-table__sort-icon"
      :class="{ _selected: itemActive }"
      width="16"
      height="16"
      @mousedown="stopPropogation"
      @click="handleSortClicked"
      @dblclick="handleSortDblClicked"
    >
      <title>
        Кликните для сортировки. Двойной клик отменяет выбор.
      </title>

      <use v-bind:xlink:href="sortingIcon" />
    </svg>
    
    <span class="table-flex-header-cell__label">
      {{configItem.label}}
    </span>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'

export default {
  props: {
    configItem: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      changeOptionsVisible: false,
      onClickTimer: null,
      onClickDelay: 300
    }
  },

  computed: {
    ...mapGetters(['searchSort']),
    fieldName() {
      return this.configItem.dataFields[0]
    },
    sortable() {
      return this.configItem.sortable && (this.searchSort.findIndex(i => i.field===this.fieldName) !== -1)
    },
    itemActive() {
      if( !this.configItem.sortable ) return false
      let num = this.searchSort.findIndex( i => i.field === this.fieldName)

      return this.searchSort[num].active
    },
    sortingIcon() {
      if( !this.configItem.sortable ) return '#sort-asc'
      let num = this.searchSort.findIndex( i => i.field === this.fieldName)

      return this.searchSort[num].asc? '#sort-asc': '#sort-desc'
    }
  },

  methods: {
    handleChangeFieldClicked(ev) {
      ev.stopImmediatePropagation()
      this.changeOptionsVisible = !this.changeOptionsVisible
    },
    stopPropogation(ev) {
      ev.stopImmediatePropagation()
    },
    handleChangeDataSource(num) {
      if(this.configItem.options.currData !== num) {
        this.$emit('change-data-source', {
          name: this.configItem.name,
          newData: num
        })
      }
      this.changeOptionsVisible = false
    },
    handleSortClicked() {
      this.onClickTimer = setTimeout(() => {
        if( !this.onClickTimer ) return

        this.onClickTimer = null;
        if( !this.itemActive ) {
          this.$store.dispatch('changeSortingFromTable', { //'changeSortParamenter', {
            name: this.fieldName,
            parameter: 'active',
            value: true
          })
        } else {
          this.$store.dispatch('changeSortingFromTable', { //'changeSortParamenter', {
            name: this.fieldName,
            parameter: 'asc',
            value: !this.searchSort[this.searchSort.findIndex( i => i.field === this.fieldName)].asc
          })          
        }
      }, this.onClickDelay)      
    },
    handleSortDblClicked() {
      if (this.onClickTimer) {
        clearTimeout(this.onClickTimer);
        this.onClickTimer = null;
      }

      if( !this.itemActive ) return
      this.$store.dispatch('changeSortParamenter', {
        name: this.fieldName,
        parameter: 'active',
        value: false
      })
    }
  }
};
</script>
